/* eslint-disable camelcase */
const reducer = (key, value) => {
    switch (key) {
        case 'date_end':
            if (value && typeof value !== 'number') return `${key} must be a number`
            break
        case 'date_start':
            if (typeof value !== 'number') return `${key} must be a number`
            break
        case 'group':
            if (typeof value !== 'string' || Number.isNaN(Number(value))) return `Must be a number`
            break
        case 'level_required':
            if (typeof value !== 'string' || Number.isNaN(Number(value))) return `Must be a number`
            break
        case 'name':
            if (typeof value !== 'string') return `${key} must be a string`
            if (value.length < 3) return `At least three characters`
            break
        case 'notes':
            if (value && typeof value !== 'string') return `${key} must be a string`
            break
        case 'countries':
            if (!(value instanceof Array)) return `Region must be an array`
            if (!value.length) return `Region must have at least one selection`
            break
        case 'purchase_order':
            if (value && typeof value !== 'string') return `${key} must be a string`
            break
        default:
            return null
    }
}

const compareValues = (values) => {
    const out = {}
    const { date_end = Number.MAX_VALUE, date_start } = values

    if (typeof date_end === 'number' && date_end <= date_start) {
        out.date_end = 'Must be later than Start Date'
    }

    return out
}

const validate = (values) => ({
    ...compareValues(values),
    ...Object.keys(values).reduce((obj, k) => {
        const out = obj
        const error = reducer(k, values[k])
        if (error) out[k] = error
        return obj
    }, {}),
})

export default validate
